import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Financeiro2 from "../components/FinanceiroLayout2";

const FinanceiroPage2 = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Financeiro 2.0" />
      <Financeiro2 />
    </MasterLayout>
  );
};

export default FinanceiroPage2;
